import {TableUserInfo} from '@components/common/users-table/users-table'

export type OptionsItem = {label: string; value: string}

export const getUsersOptions = (users: TableUserInfo[]): OptionsItem[] => {
  return users.map(x => ({
    label: x.userName,
    value: x.userId
  }))
}
